import {BrandEnum} from "utils/brand";

export enum MobileApp {
    RIDER = "rider",
    DRIVER = "driver",
    EATER = "eater",
    PROVIDER = "provider",
    COURIER = "courier",
}

export const DEEPLINK_PREFIXES: Record<BrandEnum, Record<MobileApp, string | undefined>> = {
    [BrandEnum.BOLT]: {
        [MobileApp.RIDER]: import.meta.env.VITE_RIDER_DEEPLINK_PREFIX,
        [MobileApp.DRIVER]: import.meta.env.VITE_DRIVER_DEEPLINK_PREFIX,
        [MobileApp.EATER]: import.meta.env.VITE_EATER_DEEPLINK_PREFIX,
        [MobileApp.PROVIDER]: import.meta.env.VITE_PROVIDER_DEEPLINK_PREFIX,
        [MobileApp.COURIER]: import.meta.env.VITE_COURIER_DEEPLINK_PREFIX,
    },
    [BrandEnum.HOPP]: {
        [MobileApp.RIDER]: import.meta.env.VITE_RIDER_HOPP_DEEPLINK_PREFIX,
        [MobileApp.DRIVER]: import.meta.env.VITE_DRIVER_HOPP_DEEPLINK_PREFIX,
        [MobileApp.EATER]: undefined,
        [MobileApp.PROVIDER]: undefined,
        [MobileApp.COURIER]: undefined,
    },
};
